export const actions = {
  PAISES_INFO_LOAD_REQUESTED: 'PAISES_INFO_LOAD_REQUESTED',
  PAISES_INFO_LOAD_SUCCEEDED: 'PAISES_INFO_LOAD_SUCCEEDED',
  PAISES_INFO_LOAD_FILED: 'PAISES_INFO_LOAD_FILED',

  PAISES_INFO_FILTERED_REQUESTED: 'PAISES_INFO_FILTERED_REQUESTED',
  PAISES_INFO_FILTERED_SUCCEEDED: 'PAISES_INFO_FILTERED_SUCCEEDED',
  PAISES_INFO_FILTERED_FILED: 'PAISES_INFO_FILTERED_FILED',
}

export const getPaisesInfoAction = dispatch => {
  dispatch({
    type: actions.PAISES_INFO_LOAD_REQUESTED,
  })
}

export const getPaisesInfoFilteredAction = (dispatch, payload) => {
  dispatch({
    type: actions.PAISES_INFO_LOAD_REQUESTED,
    payload,
  })
}
